// #region Imports
//let BABYLON = require("babylonjs");
import './slider.js';
import './styles.css';
import * as BABYLON from "babylonjs";
import 'babylonjs-loaders';
import * as GUI from "babylonjs-gui";
import { AnimationStep } from "./Models/animationStep.model";
import { Product } from "./Models/product.model";
import { Animation } from "./Models/animation.model";
import { UIElements } from "./Models/uiElements.model";
// #endregion

// #region Variables
var canvas = document.getElementById("renderCanvas");
var body = document.getElementById("body");
var engine = null;
var uiElements;
var scene;
var camera;
var newModel = null;
var marker = null;
var plane;
var advancedTexture;
let hitTest;
let xrTest;
var xr;
var hl;
var sky;
var sceneActive = false;
var latestHitTestTransform;
var supported;
var product;
var isFullscreen = false;
var isARActive = false;
//let divFps = document.getElementById("fps");
// #endregion
document.addEventListener("DOMContentLoaded", startGame);

async function startGame(){
    canvas = document.getElementById("renderCanvas");
    engine = new BABYLON.Engine(canvas,true);
    scene = await createScene();
    modifySettings();
    engine.runRenderLoop(function (){
        scene.render();
        //divFps.innerHTML = engine.getFps().toFixed() + " fps";
    });
    
}

var createScene = async function () {
    scene = new BABYLON.Scene(engine);
    //createCamera();
    createLights(scene);
    await spawnModel();
    createCamera();
    createUI();
    await runXR();
    //runOptimizer();
    
    return scene;
};

function runOptimizer(){
    engine.enableOfflineSupport = false;

    engine.setHardwareScalingLevel(1);

    // Options (target 70fps (which is not possible) with a check every 500ms)
    var options = new BABYLON.SceneOptimizerOptions(50, 500);
    options.addOptimization(new BABYLON.HardwareScalingOptimization(0, 1));
    options.addOptimization(new BABYLON.HardwareScalingOptimization(0, 1.5));
    options.addOptimization(new BABYLON.HardwareScalingOptimization(0, 2));

    // Optimizer
    var optimizer = new BABYLON.SceneOptimizer(scene, options);

    optimizer.onNewOptimizationAppliedObservable.add(function (optim) {
        advancedTexture.scale(optim.getDescription().split("to ").pop());
    });
    optimizer.start();
}

async function runXR(){
    supported = await BABYLON.WebXRSessionManager.IsSessionSupportedAsync('immersive-ar');
    //supported = false
    if (supported) {
        console.log("AR is supported");
        xr = await scene.createDefaultXRExperienceAsync({
            uiOptions: {
                sessionMode: "immersive-ar",
                referenceSpaceType: "viewer"
            },
            optionalFeatures: false
        });

        const fm = xr.baseExperience.featuresManager;
        xrTest = fm.enableFeature(BABYLON.WebXRHitTest.Name, "latest");
        fm.enableFeature(BABYLON.WebXRBackgroundRemover.Name);

        marker = BABYLON.MeshBuilder.CreateTorus('marker', { diameter: 0.15, thickness: 0.00001 });
        plane = BABYLON.MeshBuilder.CreatePlane("plane", {height:0.1, width: 0.1});
        var mat = new BABYLON.StandardMaterial("", scene);
        mat.diffuseTexture = new BABYLON.Texture("https://charliebehan.github.io/DromoneARDemo/textures/PlacementIcon.png", scene);
        mat.diffuseTexture.hasAlpha = true;
        plane.material = mat;
        plane.rotation = new BABYLON.Vector3(0, Math.PI / 2 , 0);
        plane.rotationQuaternion = null; 
        plane.rotation.x = Math.PI/180 * 90;
        plane.parent = marker;
        marker.isVisible = false;
        plane.isVisible = false;
        marker.rotationQuaternion = new BABYLON.Quaternion();

        xrTest.onHitTestResultObservable.add((results) => {
            if(product.root.meshes[0].isVisible)
                product.toggleMeshesVisibility();
            if (results.length) {
                marker.isVisible = true;
                plane.isVisible = true;
                if(uiElements){
                    uiElements.buttonARPlaceProduct.isVisible = true;
                    uiElements.buttonARPlaceProduct.isEnabled = true;
                    uiElements.imageARInstructions.isVisible = false;
                } 
                hitTest = results[0];
                hitTest.transformationMatrix.decompose(undefined, marker.rotationQuaternion, marker.position);
                latestHitTestTransform = hitTest.position;
            } else {
                marker.isVisible = false;
                plane.isVisible = false;
                if(uiElements){
                    uiElements.buttonARPlaceProduct.isVisible = false;
                    uiElements.imageARInstructions.isVisible = true;
                }
                hitTest = undefined;
            }
        }); 

        var classes = document.getElementsByClassName('xr-button-overlay')
        classes[0].style.width = "90px";
        classes[0].style.display  = "none";
        classes[0].style.left = "50%";
        classes[0].style.bottom = "30px";
        classes[0].style.transform = "translate(-50%, -50%)";
    }
}

async function spawnModel(){
    var index = getSecondPart(window.location.href);
    if(index == 1)
        newModel = await BABYLON.SceneLoader.ImportMeshAsync("", "https://charliebehan.github.io/models/MLQC_Anim_Mat_Steps05.glb");
    else if(index == 2)
        newModel = await BABYLON.SceneLoader.ImportMeshAsync("", "https://charliebehan.github.io/models/PUH_Anim_Mat02.glb");
    else if(index == 3)
        newModel = await BABYLON.SceneLoader.ImportMeshAsync("", "https://models.babylonjs.com/toast_acrobatics.glb");
    else
        newModel = await BABYLON.SceneLoader.ImportMeshAsync("", "https://charliebehan.github.io/models/MLQC_Anim_Mat_Steps09.glb");

    //newModel.meshes[0].scaling = new BABYLON.Vector3(0.2, 0.2, 0.2);
    //newModel.meshes[0].position = new BABYLON.Vector3(0,1.2,0);
    
    await convertModelToObject(newModel);
}

function convertModelToObject(modelRoot){
    var animation;
    var animationStep;
    var modelMeshes = modelRoot.meshes[0]

    //search for the product
    for(var i = 0; i < modelMeshes._children.length; i++){
        if(modelMeshes._children[i].id.includes("name")){
            product = new Product("{"+modelMeshes._children[i].id+"}");
            // Search for animations
            for(var j = 0; j < modelMeshes._children[i]._children.length; j++){
                if(modelMeshes._children[i]._children[j].id.includes("animationName")){
                    animation = new Animation("{"+modelMeshes._children[i]._children[j].id+"}");
                    product.animations.push(animation);
                    // Search for animation steps
                    for(var m = 0; m < modelMeshes._children[i]._children[j]._children.length; m++){
                        if(modelMeshes._children[i]._children[j]._children[m].id.includes("start")){
                            animationStep = new AnimationStep("{"+modelMeshes._children[i]._children[j]._children[m].id+"}");
                            animation.steps.push(animationStep);
                        }
                    }
                    var sorted = product.animations[j].steps.sort(function (a, b) {
                        return a.step - b.step;
                    });
                    product.animations[j].steps = sorted;
                }
                if(modelMeshes._children[i]._children[j].id.includes("camera"))
                    product.cameraLockedRef = modelMeshes._children[i]._children[j];
                if(modelMeshes._children[i]._children[j].id.includes("intro")){
                    var JSONString = "{"+modelMeshes._children[i]._children[j].id+"}";
                    let intro = JSON.parse(JSONString);
                    product.introText = intro.intro;
                    product.introImage = intro.image;
                }
            } 
        }
    }
    document.getElementById("productNameText").textContent = product.name;
    product.root = modelRoot; 
    product.rootMeshes = modelRoot.meshes;
    //product.stopAnimation();
    console.log(product);
    product.root.animationGroups.forEach(function (animationGroup) {
        animationGroup.onAnimationGroupEndObservable.add((point, data) => {
            if(uiElements != null){
                if(uiElements.buttonHome.isVisible == true)
                    product.updateCurrentStep();
            }
        })
    });
    
}

function createCamera(){
    hl = new BABYLON.HighlightLayer("hl1", scene);  
    camera = new BABYLON.ArcRotateCamera("camera", 6, 1.3, 6, product.rootMeshes[0].getBoundingInfo().boundingSphere.centerWorld, scene);
    camera.minZ = 0.01;
    camera.allowUpsideDown = false;
    camera.wheelPrecision = 150;
    camera.pinchDeltaPercentage = 0.0001;
    camera.useNaturalPinchZoom = false;
    camera.pinchPrecision = 0.0001;
    camera.panningSensibility = 0;
    //camera.attachControl(canvas, true);
    camera.position = product.cameraLockedRef.position;
    camera.rebuildAnglesAndRadius();
    camera.radius = 6;
    camera.useAutoRotationBehavior = true;
    camera.autoRotationBehavior.idleRotationSpeed = 0.6;
    camera.autoRotationBehavior.idleRotationWaitTime = 10;
    camera.autoRotationBehavior.idleRotationSpinupTime = 10;
    camera.autoRotationBehavior.zoomStopsAnimation = false;
}

function createLights(sceneRef){
    var light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(0, 1, 0), scene);
    light.intensity = 0.7;

    var dirLight = new BABYLON.DirectionalLight('light', new BABYLON.Vector3(0, -1, -0.5), scene);
    dirLight.position = new BABYLON.Vector3(0, 5, -5);

    //sceneRef.createDefaultEnvironment();
    var hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("https://charliebehan.github.io/DromoneARDemo/environment.dds", sceneRef);
    sceneRef.environmentTexture = hdrTexture;
    hdrTexture.gammaSpace = false;

    sky = scene.createDefaultSkybox(hdrTexture, true, 100, 0.5);
    
}

function createUI()
{
    advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
    uiElements = new UIElements(canvas, advancedTexture);
    product.uiElementsRef = uiElements;
    //uiElements.createLogo();
    uiElements.createStepDescription();
    uiElements.createHomeButton();    
    uiElements.createSliderZoom(camera);
    uiElements.createAnimationButtons(product);  
    if(supported){     
        uiElements.createARInstructions(isARActive);
        uiElements.createARPlacementButton(isARActive);
        uiElements.createARToggle(isARActive);
        uiElements.isARSupported = true;
    }
    uiElements.createJoysticks(product);
    uiElements.createControlPanel(product);
    uiElements.createProcedureCompleteImage();
    
    for(var i = 0; i < uiElements.buttonsAnimationType.length; i++){
        uiElements.buttonsAnimationType[i].onPointerUpObservable.add(function(point, data) {
            uiElements.displayAnimationScreen();
            product.updateCurrentAnimation(data.currentTarget.name);
            window.navigator.vibrate(50);
        });
    }
    uiElements.buttonHome.onPointerUpObservable.add(function() {
        uiElements.displayMenuScreen();
        window.navigator.vibrate(50);
     }); 
    if (supported) {
        uiElements.buttonARToggleOn.onPointerUpObservable.add(function() {
            exitXRMode();
        }); 
        uiElements.buttonARToggleOff.onPointerUpObservable.add(function() {
            enterXRMode();
        });
        uiElements.buttonARPlaceProduct.onPointerUpObservable.add(async function() {
            if(uiElements.buttonARPlaceProduct.background == "green"){
                uiElements.buttonARPlaceProduct.textBlock.text = "Restart Tracking";
                uiElements.buttonARPlaceProduct.background = "red";
                uiElements.buttonARPlaceProduct.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
                uiElements.buttonARPlaceProduct.top = "30px";
                xrTest.paused = true;
                marker.isVisible = false;
                plane.isVisible = false;
                product.toggleMeshesVisibility();
                product.root.meshes[0].position = latestHitTestTransform;
            }else{
                uiElements.buttonARPlaceProduct.textBlock.text = "Place Here"
                uiElements.buttonARPlaceProduct.background = "green"
                xrTest.paused = false;
                uiElements.buttonARPlaceProduct.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
                uiElements.buttonARPlaceProduct.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
                uiElements.buttonARPlaceProduct.top = "0px";
                product.toggleMeshesVisibility();
            } 
        });
    }
    if(sceneActive){
        uiElements.displayMenuScreen();
    }
        
}

async function enterXRMode(){
    window.navigator.vibrate(50);
    sky.isVisible = false;
    await xr.baseExperience.enterXRAsync("immersive-ar", "unbounded", xr.renderTarget);

    xrTest.paused = false;
    product.root.meshes[0].scaling = new BABYLON.Vector3(0.2, 0.2, 0.2);

    advancedTexture.dispose();
    uiElements = null
    setTimeout(function() {
        isARActive = true;
        createUI();
    }, 1000);
}
async function exitXRMode(){
    window.navigator.vibrate(50);
    marker.isVisible = false;
    plane.isVisible = false;
    sky.isVisible = true;
    if(product.root.meshes[0].isVisible == false)
        product.toggleMeshesVisibility();
    product.root.meshes[0].position = new BABYLON.Vector3(0,0,0);
    await xr.baseExperience.exitXRAsync(); 

    product.root.meshes[0].scaling = new BABYLON.Vector3(1, 1, 1);
    
    advancedTexture.dispose();
    uiElements = null
    setTimeout(function() {
        isARActive = false;
        createUI();
    }, 1000);  
}

function activateScene()
{
    window.navigator.vibrate(50);
    var slider = document.getElementsByClassName("range")[0];
    if(slider.value==100){
        if(!sceneActive)
        {
            var x = document.getElementById("temp");
            if (!sceneActive) {
                x.style.display = "none";
            } else {
                x.style.display = "block";
            }
            sceneActive =true;
            //fullscreen();
            camera.attachControl(canvas, true);
            camera.useAutoRotationBehavior = false;
            product.stopAnimation();
            camera.position = product.cameraLockedRef.position;
            camera.rebuildAnglesAndRadius();
            camera.radius = 6;
            scene.onPointerObservable.add(function(evt){
                if(evt.pickInfo.pickedMesh)
                {
                    hl.removeAllMeshes();
                    hl.addMesh(evt.pickInfo.pickedMesh, BABYLON.Color3.Yellow());
                    camera.setTarget(evt.pickInfo.pickedMesh);
                }
                if(evt.pickInfo.pickedMesh==null)
                {
                    hl.removeAllMeshes();
                }
            }, BABYLON.PointerEventTypes.POINTERTAP);
            if(uiElements != null){
                uiElements.displayMenuScreen();
            }
        }
    }
}

function modifySettings()
{
    var x = document.getElementById("loading");
    x.style.display = "none";

    x = document.getElementById("temp");
    x.style.display = "block";

    var slider = document.getElementsByClassName("range")[0];
    slider.style.display = "block";

    x = document.getElementById("sliderText");
    x.style.display = "block";

    slider.addEventListener("mouseup", activateScene, false);
    slider.addEventListener("touchend", activateScene, false);
    slider.addEventListener("mousedown", vibrate, false);
    slider.addEventListener("touchstart", vibrate, false);

    window.addEventListener("orientationchange", function() {
        advancedTexture.dispose();
        uiElements = null
        setTimeout(function() {
            createUI();
          }, 1000);
          console.log("SIDE CHANGE")
    }, false);
    document.addEventListener('fullscreenchange', function() {
        advancedTexture.dispose();
        uiElements = null
        setTimeout(function() {
            createUI();
          }, 1000);
        console.log("FULLSCREEN CHANGE")
    }, false);
}

window.addEventListener("resize", function () {
    engine.resize();
});

function fullscreen()
{
    var elem = document.getElementById("body");
    if(isFullscreen){
        document.exitFullscreen();
        isFullscreen = false;
    }else{
        elem.requestFullscreen();
        isFullscreen = true;    
    }       
}

// #region temp functions
function getSecondPart(str) {
    return str.split('?')[1];
}
function getRandomArbitrary(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}
function lerp(start, end, t) {
    return start * (1 - t) + end * t
}
function vibrate(){
    window.navigator.vibrate(50)
}

/* window.addEventListener("orientationchange", function() {
    alert("Please use Portrait!");
}); */ 
//#endregion